import { render, staticRenderFns } from "./GeneralContent.vue?vue&type=template&id=b462ea36&scoped=true"
import script from "./GeneralContent.vue?vue&type=script&lang=js"
export * from "./GeneralContent.vue?vue&type=script&lang=js"
import style0 from "./GeneralContent.vue?vue&type=style&index=0&id=b462ea36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b462ea36",
  null
  
)

export default component.exports